<template>
  <div class="grid generic-container">
    <div class="xs-12">
      <div class="grid">
        <h2 class="xs-8 dea-heading--medium__ml">
          Pacchetto: {{ registration.linked_event.title }}<br />
          <div v-if="registration.linked_event.description" class="dea-heading--regular__xm">
            {{ registration.linked_event.description }}
          </div>
        </h2>
        <div
          v-if="+registration.attendance_seconds"
          class="xs-12 l-4 ticket-container__buttons-container ticket-container__buttons-container--package"
        >
          <Links
            v-if="registration.sofia_certificate_available"
            class="dea-links--small dea-link--color-secondary-formazione dea-button--full dea-links--pointer"
            target="_blank"
            >Vai all'attestato S.O.F.I.A.</Links
          >
          <Buttons
            v-if="
              registration.is_active &&
                registration.past &&
                registration.is_event_time_reached &&
                !registration.survey_completed_date &&
                registration.linked_event.has_survey &&
                registration.dea_certificate_is_allowed &&
                !registration.dea_certificate_available
            "
            class="dea-button--large dea-button--full dea-button--iconRight"
            icon="go-to"
            @click="$emit('completeSurvey', registration)"
            >Compila il questionario e scarica l'attestato</Buttons
          >
          <Buttons
            v-if="registration.dea_certificate_available && registration.dea_certificate_url"
            class="dea-button--large dea-button--full dea-button--iconRight"
            icon="download"
            type="a"
            :href="registration.dea_certificate_url"
            target="_blank"
            >Scarica attestato</Buttons
          >
        </div>
      </div>
    </div>
    <div class="xs-12 generic-container__ticket-card-container">
      <TicketCard
        v-for="item in registration.bundle_children"
        :key="item.id"
        :registration="item"
        :editable="editable"
        :cancellable="false"
        :is-bundle-child="true"
        @editLaboratories="$emit('editLaboratories', item)"
        @completeSurvey="$emit('completeSurvey', item)"
        @downloadFiles="$emit('downloadFiles', item)"
      ></TicketCard>
    </div>
  </div>
</template>

<script>
import Links from "@/components/elements/Links";
import Buttons from "@/components/elements/Buttons";
import TicketCard from "~/components/events/components/TicketCard";

export default {
  name: "TicketPackage",
  components: {
    Links,
    TicketCard,
    Buttons,
  },
  props: {
    registration: {
      type: Object,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {},
  methods: {
    changeState(ticketFilter) {
      this.$emit("changeState", ticketFilter);
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/system.utils";

.generic-container {
  border: $border-bold $dea-color-target-magenta-formazione;
  margin-bottom: $space-large !important; //sass-lint:disable-line no-important
  padding: 0 $space-small;

  &__ticket-card-container {
    margin-top: $space-large;
  }

  &__list-intro {
    margin-bottom: $space-x-small;
  }

  &__list-events {
    & > * {
      margin-bottom: $space-small;
    }
  }

  &__detail-link {
    margin-top: $space-small;
  }
}

.ticket-container__buttons-container--package {
  padding: $space-small 0 0;
}
</style>
